// Static reference data: the 13 Anbaugebiete and their 41 Bereiche.
// Sourced from the German Wine Law (Weingesetz) official designations.
// If these change, update both this file AND the SQL seed/constraints.

export const ANBAUGEBIETE = [
  'Ahr',
  'Baden',
  'Franken',
  'Hessische Bergstraße',
  'Mittelrhein',
  'Mosel',
  'Nahe',
  'Pfalz',
  'Rheingau',
  'Rheinhessen',
  'Saale-Unstrut',
  'Sachsen',
  'Württemberg'
];

export const BEREICHE_BY_ANBAUGEBIET = {
  'Ahr': [
    'Walporzheim/Ahrtal'
  ],
  'Baden': [
    'Badische Bergstraße',
    'Bodensee',
    'Breisgau',
    'Kaiserstuhl',
    'Kraichgau',
    'Markgräflerland',
    'Ortenau',
    'Tauberfranken',
    'Tuniberg'
  ],
  'Franken': [
    'Abt Degen Weintal',
    'Alzenauer Weinregion',
    'Churfranken',
    'Frankens Saalestück',
    'Main Himmelreich',
    'MainSüden',
    'Mittelfränkische Bocksbeutelstraße',
    'Mittelmain',
    'Schwanberger Land',
    'Volkacher Mainschleife',
    'Weinpanorama Steigerwald',
    'Weinparadies'
  ],
  'Hessische Bergstraße': [
    'Starkenburg',
    'Umstadt'
  ],
  'Mittelrhein': [
    'Loreley',
    'Siebengebirge'
  ],
  'Mosel': [
    'Bernkastel',
    'Burg Cochem',
    'Moseltor',
    'Obermosel',
    'Ruwer',
    'Saar'
  ],
  'Nahe': [
    'Nahetal'
  ],
  'Pfalz': [
    'Mittelhaardt/Deutsche Weinstraße',
    'Südliche Weinstraße'
  ],
  'Rheingau': [
    'Johannisberg'
  ],
  'Rheinhessen': [
    'Bingen',
    'Nierstein',
    'Wonnegau'
  ],
  'Saale-Unstrut': [
    'Mansfelder Seen',
    'Schloss Neuenburg',
    'Thüringen',
    'Werder/Havel'
  ],
  'Sachsen': [
    'Elstertal',
    'Meißen'
  ],
  'Württemberg': [
    'Bayerischer Bodensee',
    'Kocher-Jagst-Tauber',
    'Neckar-Alb',
    'Remstal',
    'Württembergisch Unterland',
    'Württembergischer Bodensee'
  ]
};

export function bereicheFor(anbaugebiet) {
  return BEREICHE_BY_ANBAUGEBIET[anbaugebiet] ?? [];
}
